
<div class="">
  <div class="top-div">
    <div class="reports-list">
      {{labels.reports|translate}}

    </div>
  </div>
  <div class="mid-div">
    <div class="radiosec">
      <p-radioButton name="coolersUnderTenant" value='coolersUnderTenant' label={{labels.coolersUnderTenant|translate}}
                     (keypress)="changeRadio($event)"
                     (keydown)="changeRadio($event)"
                     (keyup)="changeRadio($event)" [(ngModel)]="selectedType"></p-radioButton><br>
      <p-radioButton name="userUnderTenant" value='userUnderTenant' label={{labels.userUnderTenant|translate}} (click)="changeRadio($event)"
                     (keypress)="changeRadio($event)"
                     (keydown)="changeRadio($event)"
                     (keyup)="changeRadio($event)"
                     [(ngModel)]="selectedType"></p-radioButton><br>
      <p-radioButton name="renewalNotify" value='renewalNotify' label={{labels.renewalNotify|translate}} (click)="changeRadio($event)"
                     (keypress)="changeRadio($event)"
                     (keydown)="changeRadio($event)"
                     (keyup)="changeRadio($event)" [(ngModel)]="selectedType"></p-radioButton><br>

      <div *ngIf="isEnable" class="tenantName">
        <div *ngIf="isEnable" class="row input-title">
          {{labels.tenantName |translate}}
        </div>
        <div *ngIf="isEnable" class="row">
          <p-multiSelect class="input-content-drp se-form-control" [options]="tenantList" name="tenant" ngDefaultControl
                         [(ngModel)]="selectedTenant" placeholder="Select Tenant" optionLabel="name"></p-multiSelect>

        </div>
        <div *ngIf="isDateEnable" class="dateTitle">
          <div *ngIf="isDateEnable" class="row input-title">
            {{labels.date |translate}}
          </div>

          <div *ngIf="isDateEnable" class="row">
            <p-calendar [inputStyle]="{'width':'250px','height':'35px','color':'#434343','border-top-style':'none','line-height':'85px','border-radius':'0px','border-left-style':'none','border-right-style':'none','font-family':'Nunito','font-size':'16px','border-width':'initial'}"
                      appendTo="body" readonlyInput="true" showButtonBar="true"   [(ngModel)]="selectedDate" [showIcon]="true" placeholder="Select Date">

            </p-calendar>

          </div>
        </div>

      </div><br *ngIf="isEnable">
      <br *ngIf="isEnable">
      <p-radioButton name="registeredTenant" value='registeredTenant' label={{labels.registeredTenant|translate}} (click)="changeRadio($event)"
                     (keypress)="changeRadio($event)"
                     (keydown)="changeRadio($event)"
                     (keyup)="changeRadio($event)"
                     [(ngModel)]="selectedType"></p-radioButton><br>
      <p-radioButton name="registeredUser" value='registeredUser' label={{labels.registeredUser|translate}} (click)="changeRadio($event)" (keypress)="changeRadio($event)"
                     (keydown)="changeRadio($event)"
                     (keyup)="changeRadio($event)" [(ngModel)]="selectedType"></p-radioButton><br>
      <p-radioButton name="coolersByCountry" value='coolersByCountry' label={{labels.coolersByCountry|translate}} (keypress)="changeRadio($event)"
                     (keydown)="changeRadio($event)"
                     (keyup)="changeRadio($event)" (click)="changeRadio($event)" [(ngModel)]="selectedType"></p-radioButton><br>



      <hr class="pageBreak">
      <label class="chooseFormat">{{labels.chooseFormat|translate}}</label><br>
      <div class="mt-35px">
        <p-radioButton name="exportXlsx" value='xlsx' label="" [(ngModel)]="selectedReportType"></p-radioButton>&nbsp;&nbsp;
        <img class="se-logo se-logo-img formatLogo" src='assets/xlsx.svg' alt="Xls" width="49px" height="55px"  />&nbsp;&nbsp;

        <p-radioButton name="exportCSV" value='csv' label="" [(ngModel)]="selectedReportType"></p-radioButton>&nbsp;&nbsp;
        <img class="se-logo se-logo-img formatLogo" src='assets/csv.svg' alt="Csv" width="49px" height="55px"  />&nbsp;&nbsp;
        <p-radioButton name="exportPdf" value='pdf' label="" [(ngModel)]="selectedReportType"></p-radioButton>&nbsp;&nbsp;
        <img class="se-logo se-logo-img formatLogo" src='assets/pdf.svg' alt="Pdf" width="49px" height="55px" />&nbsp;&nbsp;
      </div>
    </div>
  </div>
  <div class="bottom-div">
    <button class="se-button se-btn-reports" (click)="GenerateReport()">
      {{labels.generateReport | translate}}
    </button>

  </div>

</div>
<template ngbModalContainer>
</template>
<p-toast class="mt10" position="top-center" key="error"></p-toast>
